<template>
  <div class="h-100">
    <b-row no-gutters class="h-50">
      <b-col class="h-100 sole">
        <b-img fluid class="solegrid" :src="api('static/img/solegrid.svg')" @click="zoom(api(pair.a.sole))" />
        <b-img fluid :src="api(pair.a.sole)" class="shoeimg" @click="zoom(api(pair.a.sole))"/>
      </b-col>
      <b-col class="h-100 vamp">
        <b-img fluid :src="api(pair.a.vamp)" class="shoeimg" @click="zoom(api(pair.a.vamp))"/>
      </b-col>
      <b-col class="h-100">
        <b-img fluid :src="api(pair.a.heel)" class="shoeimg" @click="zoom(api(pair.a.heel))"/>
      </b-col>
    </b-row>
    <b-row no-gutters class="h-50">
      <b-col class="h-100 sole">
        <b-img fluid class="solegrid" :src="api('static/img/solegrid.svg')" @click="zoom(api(pair.b.sole))" />
        <b-img fluid :src="api(pair.b.sole)" class="shoeimg" @click="zoom(api(pair.b.sole))"/>
      </b-col>
      <b-col class="h-100 vamp">
        <b-img fluid :src="api(pair.b.vamp)" class="shoeimg" @click="zoom(api(pair.b.vamp))"/>
      </b-col>
      <b-col class="h-100">
        <b-img fluid :src="api(pair.b.heel)" class="shoeimg" @click="zoom(api(pair.b.heel))"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>


import {api} from "@/utils";

export default {
  name: 'ShoeImgs',
  props: ["pair"],
  methods: {
    api(url) {
      return api(url)
    },
    zoom(path) {
      this.$zoom(path, {allowZoom: false, autoScale: false, closeOnClickModal: true})
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.shoeimg {
  max-height: 100%;
  cursor: zoom-in;
}
.solegrid{
  opacity: 0;
  position: absolute;
  cursor: zoom-in;
  max-height: 100%;
}
.solegrid:hover{
  opacity: 100;

}

.imgcol {
  height: 50%
}

.sole{
  /*background: black*/
}

.vamp{
  /*background: white*/
}

</style>
